const buttonGroupContextKey = Symbol("buttonGroupContextKey");

export { buttonGroupContextKey };
//# sourceMappingURL=button.mjs.map
